// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__1fTUR","inputWrap":"CustomTip_inputWrap__2dE8Y"};